// extracted by mini-css-extract-plugin
module.exports = {"root":"UserManagement__root___Dzl1d","userTableHeader":"UserManagement__userTableHeader___PUrCA"};